import React from "react";
import Lightbox from "./Lightbox/Lightbox";
import Header from "./Header/Header";
import Preview from "./Preview/Preview";
import { getFilters, transform } from "./utils/file";
import filter from "./utils/filter";

import { getFiles } from "./api";

const removeKey = (key, { [key]: _, ...rest }) => rest;

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeFilters: {},
      files: [],
      idx: 0,
      isLoading: true,
      isLightboxOpen: false
    };
  }

  async componentDidMount() {
    const { data } = await getFiles();
    const files = transform(data);

    this.setState({
      files,
      originalFiles: files,
      filters: getFilters(files),
      isLoading: false
    });
  }

  clickFile = (idx) => {
    this.setState({ isLightboxOpen: true, idx });
  };

  filter = (key, value) => {
    const { activeFilters, originalFiles } = this.state;
    const newFilters =
      value === key
        ? removeKey(key, activeFilters)
        : { ...activeFilters, [key]: value };

    return this.setState({
      activeFilters: newFilters,
      files: filter(originalFiles, newFilters)
    });
  };

  render() {
    const {
      activeFilters,
      files,
      filters,
      idx,
      isLoading,
      isLightboxOpen
    } = this.state;

    return (
      <React.Fragment>
        <Header
          activeFilters={activeFilters}
          filters={filters}
          isLoading={isLoading}
          onFilter={this.filter}
        />
        {!isLoading && (
          <Preview
            files={files}
            onFileClick={this.clickFile}
          />
        )}
        {isLightboxOpen && (
          <Lightbox
            idx={idx}
            onClose={() => this.setState({ isLightboxOpen: false })}
            files={files.map(file => file.url.replace("thumbs", "large"))}
          />
        )}
      </React.Fragment>
    );
  }
}
